import { Component, inject, Input } from '@angular/core';
import { TuiTable } from '@taiga-ui/addon-table';
import { TuiButton, TuiHint } from '@taiga-ui/core';
import { CommonModule } from '@angular/common';
import { User } from '../../models/user';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-medecin-row',
  standalone: true,
  imports: [TuiTable, CommonModule, TuiHint, RouterLink, TuiButton],
  templateUrl: './medecin-row.component.html',
  styleUrl: './medecin-row.component.scss',
})
export class MedecinRowComponent {
  @Input() user: User | undefined;

  protected readonly authService = inject(AuthService);
  protected readonly userService = inject(UserService);
  protected readonly commonService = inject(CommonService);

  switchActif(nouveauStatut: boolean) {
    if (this.user) {
      this.user.actif = nouveauStatut;
      this.userService.push(this.user).subscribe({
        error: () => {
          this.commonService.showErrorAlert(
            `${nouveauStatut ? 'Réactivation' : 'Désactivation'} de ${this.user!.nom} ${this.user!.prenom} a échoué.`,
          );
          this.user!.actif = !nouveauStatut;
        },
      });
    }
  }
}
